<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
import JSEncrypt from "jsencrypt";
// import {encrypt,decrypt} from "./RSA"
import {
  queryEvaluationRecordList,
  getIssessQuestionNaireList,
  getQuestionPreViewData,
  queryAnswerRecord,
  reportPreview,
  thirdPartyIsOpen, //第三方接口校验是否开启
  getPublicKey,
} from "@/api/api.js";

export default {
  name: "App",
  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true, //控制视图是否显示的变量
      result: "",
    };
  },
  watch: {
  },
  created() {
   
    this.search();
    this.getUrlParam();
  },
  mounted(){
    // if (
    //   /Mobi|Android|iPhone/i.test(navigator.userAgent) ||
    //   typeof window.orientation !== "undefined"
    // ) {
    //   this.$router.push("/phoneRotation");
    // }
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    },
    // //判断是否移动端，如果是则跳转到指定的URL地址
    // browserRedirect(url) {
    //     //只读的字符串，声明了浏览器用于 HTTP 请求的用户代理头的值
    //     var sUserAgent = navigator.userAgent.toLowerCase();
    //     var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    //     var bIsMidp = sUserAgent.match(/midp/i) == "midp";
    //     var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    //     var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
    //     var bIsAndroid = sUserAgent.match(/android/i) == "android";
    //     var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
    //     var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
    //     if (bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
    //         window.location.replace('../components/phoneRotation');
    //     }
    // },
    search() {
      console.log("查看地址栏", window.location);
    },

    getUrlParam() {
      // const url = this.$route.fullPath.split("?")[1];
      const url = window.location.hash.split("?")[1];
      // getPublicKey().then((res) => {
      //   console.log(res);
      //   if (res.code == 1000) {
      //     let publicKey = res.data;
      //     let encryptor = new JSEncrypt(); // 新建JSEncrypt对象
      //     encryptor.setPublicKey(publicKey); // 设置公钥
      //     var rsaPassWord = encryptor.encrypt(
      //       "client1234567890,123456789012345678,1,一级"
      //     ); // 对密码进行加密

      //     console.log('ciphertext',rsaPassWord);
      //     sessionStorage.setItem("ciphertext", rsaPassWord);
      //     sessionStorage.setItem("publicKey", res.data);

      //   //              let obg={
      //   //  ciphertext:rsaPassWord,
      //   //  publicKey: res.data,
      //   // }

      //   //       thirdPartyIsOpen( this.$qs.stringify(obg)).then((res)=>{
      //   //  if(res.code==9000){
      //   //     this.$router.push({ name: "Empty",query:{msg:res.msg} });
      //   //  }
      //   // })

      //   }
      // });
if(!url) return
      const kv = url.split("&");
      console.log(kv);
      const list = [];
      for (var i = 0; i < kv.length; i++) {
        console.log(kv[0].split("=")[0]);
        if (kv[0].split("=")[0] === "ciphertext") {
          const value = kv[i].split("=")[1];
          console.log(value);
          list.push(value);
        }
      }

      if (list.length != 0) {
        let arr = decodeURIComponent(list[0]);
        let arrs = [];
        let nanrrr = Object.values(arr);
        nanrrr.forEach((el) => {
          if (el === " ") {
            console.log(el);
            el = "+";
          }
          arrs.push(el);
        });

        let arra = decodeURIComponent(list[1]);
        let arrsa = [];
        let nanrrra = Object.values(arra);
        nanrrra.forEach((el) => {
          if (el === " ") {
            console.log(el);
            el = "+";
          }
          arrsa.push(el);
        });

        let ciphertext = arrs.join("");
        let publicKey = arrsa.join("");

        sessionStorage.setItem("ciphertext", ciphertext);
        sessionStorage.setItem("publicKey", publicKey);

        let obg = {
          ciphertext: ciphertext,
          publicKey: publicKey,
        };
        console.log(obg);
        thirdPartyIsOpen(this.$qs.stringify(obg)).then((res) => {
          if (res.code == 9000) {
            this.$router.push({ name: "Empty", query: { msg: res.msg } });
          }
        });
      }
    },
    reload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true; //再打开
      });
    },
  },
};
</script>


<style lang="less">
html,
body {
  margin: 0;
  padding: 0;
  min-width: 100%;
  height: 100%;
  width: 100%;
  background: #f6f8fe;
  // box-sizing: border-box;
  // max-width: 1920px
  // overflow-x: hidden;
}
#app {
  width: 100%;
  height: 100%;
  // background: #f6f8fe;
  // box-sizing: border-box;
}

// html,body{min-width:1440px;min-height:500px;max-width: 2400px;}

// @media only screen and (min-width: 1200px) {
// html, body {min-width: 1200px; min-height: 500px;}
// }

//   @media screen and (min-width: 1440px) {
//  body { font-size: 12px;}
//  p{font-size: 12px;}
//  }
//  @media screen and (min-height:900px) {
//  body { font-size: 12px;}
//  }

//     @media screen and (max-width: 1200px) {
//    body { font-size: 14px;}
//    }
//     @media screen and (max-width: 1000px) {
//    body { font-size: 12px;}
//    }
//     @media screen and (max-width: 800px) {

//    }
//     @media screen and (max-width: 700px) {
//    body { font-size: 7px;}
//    }
//     @media screen and (max-width: 600px) {
//    body { font-size: 6px;}
//    }

/* pc width > 1100px */
// html, body { margin: 0;padding: 0;width: 100%;height: 100%;}

// @media screen and (max-width: 1920px) {
//    body { font-size: 14px;}
//    }

// html, body { min-width: 1200px;min-height: 500px;}

// @media only screen and (min-width: 1200px) {
//     html, body { min-width: 1200px; min-height: 500px;}
// }

main {
  height: 100%;
  background-color: blue;
  // overflow: hidden;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;

  width: 100%;
}

* {
  margin: 0;
  padding: 0;
  list-style: none;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
